var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Mouse',[_c('Header'),_vm._v(" "),_c('TransitionBars'),_vm._v(" "),_c('main',{class:{ blur: _vm.menuIsOpen }},[_c('router-view')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.menuIsOpen)?_c('Menu'):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showVideo)?_c('Video'):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f0e850","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 